const Systems ="one" 

export default Systems;
